/** A stopped incompatible connection needs an explicit action, not retry spam. */
export class GameUpdateNotice {
  private readonly dialog: HTMLDialogElement;

  public constructor(root: HTMLElement, leave: () => void) {
    const dialog = root.querySelector<HTMLDialogElement>('[data-game-update]');
    const reload = root.querySelector<HTMLButtonElement>('[data-game-update-reload]');
    const station = root.querySelector<HTMLButtonElement>('[data-game-update-station]');
    if (!dialog || !reload || !station) throw new Error('Game update controls are missing');
    this.dialog = dialog;
    reload.addEventListener('click', () => location.reload());
    station.addEventListener('click', () => { dialog.close(); leave(); });
    dialog.addEventListener('cancel', (event) => event.preventDefault());
  }

  public show(): void {
    if (document.pointerLockElement) document.exitPointerLock();
    if (!this.dialog.open) this.dialog.showModal();
  }
}
